import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOverscroll]'
})
export class OverscrollDirective {
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    // Your custom overscroll handling logic here
    console.log('Overscroll detected:', event);
  }
}
